// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import ElementFeedback from "./element-feedback.js"
import Option from "./option.js"
import OptionPosition from "./option-position.js"
import Step from "./step.js"

const modelClassData = {
  "attributes": {
    "active": {
      "column": {
        "default": true,
        "name": "active",
        "null": false,
        "type": "boolean"
      },
      "name": "active",
      "selected_by_default": null,
      "translated": null
    },
    "answer_amount": {
      "column": {
        "default": 0,
        "name": "answer_amount",
        "null": false,
        "type": "integer"
      },
      "name": "answer_amount",
      "selected_by_default": null,
      "translated": null
    },
    "anonymize_answers_after_days": {
      "column": {
        "default": null,
        "name": "anonymize_answers_after_days",
        "null": true,
        "type": "integer"
      },
      "name": "anonymize_answers_after_days",
      "selected_by_default": null,
      "translated": null
    },
    "box_height": {
      "column": {
        "default": null,
        "name": "box_height",
        "null": true,
        "type": "integer"
      },
      "name": "box_height",
      "selected_by_default": null,
      "translated": null
    },
    "box_width": {
      "column": {
        "default": null,
        "name": "box_width",
        "null": true,
        "type": "integer"
      },
      "name": "box_width",
      "selected_by_default": null,
      "translated": null
    },
    "elaborate_answer": {
      "column": {
        "default": false,
        "name": "elaborate_answer",
        "null": false,
        "type": "boolean"
      },
      "name": "elaborate_answer",
      "selected_by_default": null,
      "translated": null
    },
    "element_type": {
      "column": {
        "default": null,
        "name": "element_type",
        "null": false,
        "type": "string"
      },
      "name": "element_type",
      "selected_by_default": null,
      "translated": null
    },
    "file_filename": {
      "column": null,
      "name": "file_filename",
      "selected_by_default": null,
      "translated": null
    },
    "file_path": {
      "column": null,
      "name": "file_path",
      "selected_by_default": null,
      "translated": null
    },
    "gain_points_for_partly_correct_solutions": {
      "column": {
        "default": true,
        "name": "gain_points_for_partly_correct_solutions",
        "null": false,
        "type": "boolean"
      },
      "name": "gain_points_for_partly_correct_solutions",
      "selected_by_default": null,
      "translated": null
    },
    "hide_question": {
      "column": {
        "default": false,
        "name": "hide_question",
        "null": true,
        "type": "boolean"
      },
      "name": "hide_question",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "image_path": {
      "column": null,
      "name": "image_path",
      "selected_by_default": null,
      "translated": null
    },
    "is_question_check": {
      "column": null,
      "name": "is_question_check",
      "selected_by_default": null,
      "translated": null
    },
    "is_question_sentence": {
      "column": null,
      "name": "is_question_sentence",
      "selected_by_default": null,
      "translated": null
    },
    "is_question_text": {
      "column": null,
      "name": "is_question_text",
      "selected_by_default": null,
      "translated": null
    },
    "is_question_text_with_certain_words": {
      "column": null,
      "name": "is_question_text_with_certain_words",
      "selected_by_default": null,
      "translated": null
    },
    "is_question_radio": {
      "column": null,
      "name": "is_question_radio",
      "selected_by_default": null,
      "translated": null
    },
    "main_text": {
      "column": {
        "default": null,
        "name": "main_text",
        "null": true,
        "type": "string"
      },
      "name": "main_text",
      "selected_by_default": null,
      "translated": null
    },
    "position": {
      "column": {
        "default": null,
        "name": "position",
        "null": true,
        "type": "integer"
      },
      "name": "position",
      "selected_by_default": null,
      "translated": null
    },
    "required_answer": {
      "column": {
        "default": false,
        "name": "required_answer",
        "null": true,
        "type": "boolean"
      },
      "name": "required_answer",
      "selected_by_default": null,
      "translated": null
    },
    "step_id": {
      "column": {
        "default": null,
        "name": "step_id",
        "null": true,
        "type": "uuid"
      },
      "name": "step_id",
      "selected_by_default": null,
      "translated": null
    },
    "text_limit_answer": {
      "column": {
        "default": 0,
        "name": "text_limit_answer",
        "null": true,
        "type": "integer"
      },
      "name": "text_limit_answer",
      "selected_by_default": null,
      "translated": null
    },
    "video_autoplay": {
      "column": {
        "default": false,
        "name": "video_autoplay",
        "null": false,
        "type": "boolean"
      },
      "name": "video_autoplay",
      "selected_by_default": null,
      "translated": null
    },
    "video_url": {
      "column": {
        "default": null,
        "name": "video_url",
        "null": true,
        "type": "string"
      },
      "name": "video_url",
      "selected_by_default": null,
      "translated": null
    },
    "answers_count": {
      "column": null,
      "name": "answers_count",
      "selected_by_default": false,
      "translated": null
    },
    "audio_content_type": {
      "column": null,
      "name": "audio_content_type",
      "selected_by_default": false,
      "translated": null
    },
    "audio_path": {
      "column": null,
      "name": "audio_path",
      "selected_by_default": false,
      "translated": null
    },
    "file": {
      "column": null,
      "name": "file",
      "selected_by_default": false,
      "translated": null
    },
    "option_position_positions": {
      "column": null,
      "name": "option_position_positions",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "Element",
  "collectionKey": "elements",
  "collectionName": "elements",
  "i18nKey": "element",
  "camelizedLower": "element",
  "name": "Element",
  "nameDasherized": "element",
  "pluralName": "elements",
  "ransackable_associations": [
    {
      "className": "Answer",
      "collectionName": "answers",
      "foreignKey": "user_element_id",
      "name": "answers",
      "macro": "has_many",
      "resource_name": "Answer",
      "through": "user_elements"
    },
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": "active_storage_attachments",
      "foreignKey": "record_id",
      "name": "audio_file_attachment",
      "macro": "has_one",
      "resource_name": "ActiveStorageAttachment",
      "through": null
    },
    {
      "className": "ActiveStorage::Blob",
      "collectionName": "active_storage_blobs",
      "foreignKey": "blob_id",
      "name": "audio_file_blob",
      "macro": "has_one",
      "resource_name": "ActiveStorageBlob",
      "through": "audio_file_attachment"
    },
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": "active_storage_attachments",
      "foreignKey": "record_id",
      "name": "document_attachment",
      "macro": "has_one",
      "resource_name": "ActiveStorageAttachment",
      "through": null
    },
    {
      "className": "ActiveStorage::Blob",
      "collectionName": "active_storage_blobs",
      "foreignKey": "blob_id",
      "name": "document_blob",
      "macro": "has_one",
      "resource_name": "ActiveStorageBlob",
      "through": "document_attachment"
    },
    {
      "className": "ElementFeedback",
      "collectionName": "element_feedbacks",
      "foreignKey": "element_id",
      "name": "element_feedbacks",
      "macro": "has_many",
      "resource_name": "ElementFeedback",
      "through": null
    },
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": "active_storage_attachments",
      "foreignKey": "record_id",
      "name": "image_file_attachment",
      "macro": "has_one",
      "resource_name": "ActiveStorageAttachment",
      "through": null
    },
    {
      "className": "ActiveStorage::Blob",
      "collectionName": "active_storage_blobs",
      "foreignKey": "blob_id",
      "name": "image_file_blob",
      "macro": "has_one",
      "resource_name": "ActiveStorageBlob",
      "through": "image_file_attachment"
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "OptionPosition",
      "collectionName": "option_positions",
      "foreignKey": "option_id",
      "name": "option_positions",
      "macro": "has_many",
      "resource_name": "OptionPosition",
      "through": "options"
    },
    {
      "className": "Option",
      "collectionName": "options",
      "foreignKey": "element_id",
      "name": "options",
      "macro": "has_many",
      "resource_name": "Option",
      "through": null
    },
    {
      "className": "Step",
      "collectionName": "steps",
      "foreignKey": "step_id",
      "name": "step",
      "macro": "belongs_to",
      "resource_name": "Step",
      "through": null
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "survey",
      "macro": "has_one",
      "resource_name": "Survey",
      "through": "step"
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "UserElement",
      "collectionName": "user_elements",
      "foreignKey": "element_id",
      "name": "user_elements",
      "macro": "has_many",
      "resource_name": "UserElement",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "active",
      "column": {
        "default": true,
        "name": "active",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "anonymize_answers_after_days",
      "column": {
        "default": null,
        "name": "anonymize_answers_after_days",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "answer_amount",
      "column": {
        "default": 0,
        "name": "answer_amount",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "box_height",
      "column": {
        "default": null,
        "name": "box_height",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "box_width",
      "column": {
        "default": null,
        "name": "box_width",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "elaborate_answer",
      "column": {
        "default": false,
        "name": "elaborate_answer",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "element_type",
      "column": {
        "default": null,
        "name": "element_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "gain_points_for_partly_correct_solutions",
      "column": {
        "default": true,
        "name": "gain_points_for_partly_correct_solutions",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "hide_question",
      "column": {
        "default": false,
        "name": "hide_question",
        "null": true,
        "type": "boolean"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "main_text",
      "column": {
        "default": null,
        "name": "main_text",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_step_id",
      "column": {
        "default": null,
        "name": "old_step_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "position",
      "column": {
        "default": null,
        "name": "position",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "required_answer",
      "column": {
        "default": false,
        "name": "required_answer",
        "null": true,
        "type": "boolean"
      }
    },
    {
      "name": "step_id",
      "column": {
        "default": null,
        "name": "step_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "text_limit_answer",
      "column": {
        "default": 0,
        "name": "text_limit_answer",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "video_autoplay",
      "column": {
        "default": false,
        "name": "video_autoplay",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "video_url",
      "column": {
        "default": null,
        "name": "video_url",
        "null": true,
        "type": "string"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "ordered"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    },
    {
      "name": "unique"
    },
    {
      "name": "with_feedback"
    }
  ],
  "relationships": [
    {
      "className": "ElementFeedback",
      "collectionName": "element_feedbacks",
      "foreignKey": "element_id",
      "name": "element_feedbacks",
      "macro": "has_many",
      "resource_name": "ElementFeedback",
      "through": null
    },
    {
      "className": "Option",
      "collectionName": "options",
      "foreignKey": "element_id",
      "name": "options",
      "macro": "has_many",
      "resource_name": "Option",
      "through": null
    },
    {
      "className": "OptionPosition",
      "collectionName": "option_positions",
      "foreignKey": "option_id",
      "name": "option_positions",
      "macro": "has_many",
      "resource_name": "OptionPosition",
      "through": "options"
    },
    {
      "className": "Step",
      "collectionName": "steps",
      "foreignKey": "step_id",
      "name": "step",
      "macro": "belongs_to",
      "resource_name": "Step",
      "through": null
    }
  ],
  "paramKey": "element",
  "primaryKey": "id"
}

/** Frontend model for Element. */
export default class Element extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {boolean} */
  active() {
    return this.readAttributeUnderscore("active")
  }

  /** @returns {boolean} */
  hasActive() {
    const value = this.active()

    return this._isPresent(value)
  }

  /** @returns {number} */
  answerAmount() {
    return this.readAttributeUnderscore("answer_amount")
  }

  /** @returns {boolean} */
  hasAnswerAmount() {
    const value = this.answerAmount()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  anonymizeAnswersAfterDays() {
    return this.readAttributeUnderscore("anonymize_answers_after_days")
  }

  /** @returns {boolean} */
  hasAnonymizeAnswersAfterDays() {
    const value = this.anonymizeAnswersAfterDays()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  boxHeight() {
    return this.readAttributeUnderscore("box_height")
  }

  /** @returns {boolean} */
  hasBoxHeight() {
    const value = this.boxHeight()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  boxWidth() {
    return this.readAttributeUnderscore("box_width")
  }

  /** @returns {boolean} */
  hasBoxWidth() {
    const value = this.boxWidth()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  elaborateAnswer() {
    return this.readAttributeUnderscore("elaborate_answer")
  }

  /** @returns {boolean} */
  hasElaborateAnswer() {
    const value = this.elaborateAnswer()

    return this._isPresent(value)
  }

  /** @returns {string} */
  elementType() {
    return this.readAttributeUnderscore("element_type")
  }

  /** @returns {boolean} */
  hasElementType() {
    const value = this.elementType()

    return this._isPresent(value)
  }

  /** @returns {any} */
  fileFilename() {
    return this.readAttributeUnderscore("file_filename")
  }

  /** @returns {boolean} */
  hasFileFilename() {
    const value = this.fileFilename()

    return this._isPresent(value)
  }

  /** @returns {any} */
  filePath() {
    return this.readAttributeUnderscore("file_path")
  }

  /** @returns {boolean} */
  hasFilePath() {
    const value = this.filePath()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  gainPointsForPartlyCorrectSolutions() {
    return this.readAttributeUnderscore("gain_points_for_partly_correct_solutions")
  }

  /** @returns {boolean} */
  hasGainPointsForPartlyCorrectSolutions() {
    const value = this.gainPointsForPartlyCorrectSolutions()

    return this._isPresent(value)
  }

  /** @returns {boolean | null} */
  hideQuestion() {
    return this.readAttributeUnderscore("hide_question")
  }

  /** @returns {boolean} */
  hasHideQuestion() {
    const value = this.hideQuestion()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any} */
  imagePath() {
    return this.readAttributeUnderscore("image_path")
  }

  /** @returns {boolean} */
  hasImagePath() {
    const value = this.imagePath()

    return this._isPresent(value)
  }

  /** @returns {any} */
  isQuestionCheck() {
    return this.readAttributeUnderscore("is_question_check")
  }

  /** @returns {boolean} */
  hasIsQuestionCheck() {
    const value = this.isQuestionCheck()

    return this._isPresent(value)
  }

  /** @returns {any} */
  isQuestionSentence() {
    return this.readAttributeUnderscore("is_question_sentence")
  }

  /** @returns {boolean} */
  hasIsQuestionSentence() {
    const value = this.isQuestionSentence()

    return this._isPresent(value)
  }

  /** @returns {any} */
  isQuestionText() {
    return this.readAttributeUnderscore("is_question_text")
  }

  /** @returns {boolean} */
  hasIsQuestionText() {
    const value = this.isQuestionText()

    return this._isPresent(value)
  }

  /** @returns {any} */
  isQuestionTextWithCertainWords() {
    return this.readAttributeUnderscore("is_question_text_with_certain_words")
  }

  /** @returns {boolean} */
  hasIsQuestionTextWithCertainWords() {
    const value = this.isQuestionTextWithCertainWords()

    return this._isPresent(value)
  }

  /** @returns {any} */
  isQuestionRadio() {
    return this.readAttributeUnderscore("is_question_radio")
  }

  /** @returns {boolean} */
  hasIsQuestionRadio() {
    const value = this.isQuestionRadio()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  mainText() {
    return this.readAttributeUnderscore("main_text")
  }

  /** @returns {boolean} */
  hasMainText() {
    const value = this.mainText()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  position() {
    return this.readAttributeUnderscore("position")
  }

  /** @returns {boolean} */
  hasPosition() {
    const value = this.position()

    return this._isPresent(value)
  }

  /** @returns {boolean | null} */
  requiredAnswer() {
    return this.readAttributeUnderscore("required_answer")
  }

  /** @returns {boolean} */
  hasRequiredAnswer() {
    const value = this.requiredAnswer()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  stepId() {
    return this.readAttributeUnderscore("step_id")
  }

  /** @returns {boolean} */
  hasStepId() {
    const value = this.stepId()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  textLimitAnswer() {
    return this.readAttributeUnderscore("text_limit_answer")
  }

  /** @returns {boolean} */
  hasTextLimitAnswer() {
    const value = this.textLimitAnswer()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  videoAutoplay() {
    return this.readAttributeUnderscore("video_autoplay")
  }

  /** @returns {boolean} */
  hasVideoAutoplay() {
    const value = this.videoAutoplay()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  videoUrl() {
    return this.readAttributeUnderscore("video_url")
  }

  /** @returns {boolean} */
  hasVideoUrl() {
    const value = this.videoUrl()

    return this._isPresent(value)
  }

  /** @returns {any} */
  answersCount() {
    return this.readAttributeUnderscore("answers_count")
  }

  /** @returns {boolean} */
  hasAnswersCount() {
    const value = this.answersCount()

    return this._isPresent(value)
  }

  /** @returns {any} */
  audioContentType() {
    return this.readAttributeUnderscore("audio_content_type")
  }

  /** @returns {boolean} */
  hasAudioContentType() {
    const value = this.audioContentType()

    return this._isPresent(value)
  }

  /** @returns {any} */
  audioPath() {
    return this.readAttributeUnderscore("audio_path")
  }

  /** @returns {boolean} */
  hasAudioPath() {
    const value = this.audioPath()

    return this._isPresent(value)
  }

  /** @returns {any} */
  file() {
    return this.readAttributeUnderscore("file")
  }

  /** @returns {boolean} */
  hasFile() {
    const value = this.file()

    return this._isPresent(value)
  }

  /** @returns {any} */
  optionPositionPositions() {
    return this.readAttributeUnderscore("option_position_positions")
  }

  /** @returns {boolean} */
  hasOptionPositionPositions() {
    const value = this.optionPositionPositions()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  duplicate(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "duplicate",
        primaryKey: this.primaryKey(),
        collectionName: "elements",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  sortElementFeedbacks(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "sort_element_feedbacks",
        primaryKey: this.primaryKey(),
        collectionName: "elements",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  sortOptions(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "sort_options",
        primaryKey: this.primaryKey(),
        collectionName: "elements",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  videoEmbedHtml(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "video_embed_html",
        primaryKey: this.primaryKey(),
        collectionName: "elements",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./element-feedback.js").default>} */
  elementFeedbacks() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["element_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "element_feedbacks",
        model: this,
        modelClass: ElementFeedback
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./element-feedback.js").default>>} */
  loadElementFeedbacks() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["element_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "element_feedbacks",
        model: this,
        modelClass: ElementFeedback
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./element-feedback.js").default>>} */
  ensureElementFeedbacksLoaded() {
    return this.ensureAssociationLoaded("element_feedbacks")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./option.js").default>} */
  options() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["element_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "options",
        model: this,
        modelClass: Option
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./option.js").default>>} */
  loadOptions() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["element_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "options",
        model: this,
        modelClass: Option
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./option.js").default>>} */
  ensureOptionsLoaded() {
    return this.ensureAssociationLoaded("options")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./option-position.js").default>} */
  optionPositions() {
    return new Collection(
      {
        reflectionName: "option_positions",
        model: this,
        modelClass: OptionPosition
      },
      {
        params: {
          through: {
            model: "Element",
            id: this.primaryKey(),
            reflection: "option_positions"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./option-position.js").default>>} */
  loadOptionPositions() {
    return this._loadHasManyReflection(
      {
        reflectionName: "option_positions",
        model: this,
        modelClass: OptionPosition
      },
      {
        params: {
          through: {
            model: "Element",
            id: this.primaryKey(),
            reflection: "option_positions"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./option-position.js").default>>} */
  ensureOptionPositionsLoaded() {
    return this.ensureAssociationLoaded("option_positions")
  }

  /** @returns {import("./step.js").default | null} */
  step() {
    return this._readBelongsToReflection({modelClass: Step, reflectionName: "step"})
  }

  /** @returns {Promise<import("./step.js").default | null>} */
  loadStep() {
    if (!("stepId" in this)) throw new Error("Foreign key method wasn't defined: stepId")

    const id = this.stepId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "step",
        model: this,
        modelClass: Step
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./step.js").default | null>} */
  ensureStepLoaded() {
    return this.ensureAssociationLoaded("step")
  }
}
